import script from "./EditStatimg.vue?vue&type=script&setup=true&lang=js"
export * from "./EditStatimg.vue?vue&type=script&setup=true&lang=js"

import "./EditStatimg.vue?vue&type=style&index=0&id=160acffa&lang=css"

const __exports__ = script;

export default __exports__